import { Component, AfterViewInit, ElementRef, ChangeDetectionStrategy, inject, CUSTOM_ELEMENTS_SCHEMA, viewChild, input } from '@angular/core';
import { ModalController, IonContent, IonFooter, IonRow, IonCol, IonButton, IonIcon } from '@ionic/angular';

import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

register();

@Component({
    selector: 'my-image-swiper-preview-modal',
    templateUrl: './my-image-swiper-preview.component.html',
    styleUrls: ['./my-image-swiper-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonFooter,
        IonRow,
        IonCol,
        IonButton,
        MatIcon,
        IonIcon,
        TranslatePipe,
    ],
    // Web components de Swiper (swiper-container / swiper-slide)
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyImageSwiperPreviewModal implements AfterViewInit {
    private modalCtrl = inject(ModalController);

    readonly urlImage = input<string>(undefined);

    readonly swiperEl = viewChild<ElementRef>('swiperEl');

    config: SwiperOptions = {
        zoom: {
            maxRatio: 6,
            minRatio: 0.5,
        },
    };

    constructor() {
        addIcons({ close });
    }

    ngAfterViewInit() {
        const swiperEl = this.swiperEl();
        Object.assign(swiperEl.nativeElement, this.config);
        swiperEl.nativeElement.initialize();
    }

    zoom(zoomIn: boolean) {
        // console.log('ZoomIn: ', zoomIn);

        const zoom = this.swiperEl().nativeElement.swiper.zoom;

        if (zoomIn) {
            zoom.in();
        } else {
            zoom.out();
        }
    }

    close() {
        // console.log('Click Close!');

        this.modalCtrl.dismiss();
    }
}
